//@ts-nocheck
import axios from "axios";
import i18n from "i18n";
import { API_URL } from "constants/constants";
import { getCookieFromBrowser, removeCookie } from "utils/session";
import { error as toastError } from "components/alert/toast";

const request = axios.create({
  baseURL: API_URL,
  timeout: 16000,
});

request.interceptors.request.use(
  (config) => {
    const token = getCookieFromBrowser("access_token");
    const locale = i18n.language;
    if (token) {
      config.headers.Authorization = token;
    }
    config.params = { lang: locale, ...config.params };
    return config;
  },

  (error) => errorHandler(error),
);

function errorHandler(error) {
  if (error?.response) {
    const errorResponse = error.response?.data ?? error;
    let errorMessage = errorResponse?.message;

    if (errorResponse?.params) {
      errorMessage = Object.values(
        errorResponse.params as Record<string, string[]>,
      )?.[0]?.[0];
    }

    // 👇 prendiamo lo status e verifichiamo se c'è ancora il token
    const status = error?.response?.status;
    const hasToken = !!getCookieFromBrowser("access_token");

    if (status === 401) {
      // 🔐 Se il token ESISTE, è una vera scadenza → toast + logout forzato
      if (hasToken) {
        toastError(i18n.t("unauthorized"), {
          toastId: "unauthorized",
        });
        removeCookie("user");
        removeCookie("access_token");
        if (typeof window !== "undefined" && window.location.pathname !== "/") {
          window.location.replace("/");
        }
      }
      // Se NON c'è token (es. dopo logout), niente toast/redirect
      throw new Error(errorMessage || "Unauthorized");
    }

    throw new Error(errorMessage);
  }

  return Promise.reject(error?.response);
}

request.interceptors.response.use((response) => response.data, errorHandler);

export default request;
